import React from 'react';
import { Tooltip } from 'react-tooltip'

export default function PendingUserTableApproveButton(props: { isEmailConfirmed: boolean, onClick: () => void }) {
    const disabledMessage = 'Email must be confirmed before approving account.';
    const buttonDisabledTooltipId = 'button-disabled-tooltip';

    return (
        <span data-tooltip-id={buttonDisabledTooltipId} data-tooltip-content={props.isEmailConfirmed ? '' : disabledMessage}>
            <button className='btn btn-primary btn-sm me-2' disabled={!props.isEmailConfirmed} onClick={props.onClick}>
                <i className='bi bi-check2'></i> Approve Admin Account
            </button>
            <Tooltip id={buttonDisabledTooltipId} />
        </span>  
    );
}
